module.exports = __webpack_public_path__ + "static/media/profile-action-icon-new-insight.27a12619.svg";